export default "{\n    \"header\": \"Punto de Contacto\",\n    \"fullName\": \"Nombre Completo\",\n    \"phoneNumber\": \"Número de Teléfono\"\n}\n"